import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';
import { SetComponentLanguage, ApiRequest } from '../../helpers';
import Message from '../Common/Message/Message';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './ForgotPassword.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class ForgotPassword extends Component {
	constructor(props) {
        super(props);
        this.state = {  
            username: undefined,
            validation: {
				username: {
					valid: null,
					msg: ''
				}
            },
            isReadyToSubmit : false,
            message: {
                title: '',
                content: '',
                type: ''
            }
        };
    }

    sendEmail = (e) => {
        this.setMessage('', '', 'loading');
        const username = this.state.username;

        (async () => {
            try {
                const response = await send_email(username);
                console.log('Response: ', response);
                if(response.data.success){
                    this.setMessage(window.general_strings.msg.yay, strings.msg.success, 'success');
                } else {
                    this.setMessage(window.general_strings.msg.oops, response.data.error.code, 'error');
                }
                this.setState({ username:undefined });
            } catch (error) {
                console.log(error);
            }
        })()

        async function send_email(username) {
            return await ApiRequest(`/auth/forgot-password`, {
                method: 'POST',
                data: {
                    username: username
                }
            });
        }
        e.preventDefault();
    }

    handleChange = (e) => {
		let value = e.target.value;
		let name = e.target.attributes.getNamedItem('name').value;
        this.setState({ username:value });
        if (e.target.attributes.getNamedItem('validation')) {
            const validationRegEx = e.target.attributes.getNamedItem('validation').value;
            this.validate(value, name, validationRegEx);
        }
        this.validateAllRequiredFields();
    }

    validate = (value, name, validationRegEx) => {
        const validation = { ...this.state.validation };
        let isValid = true;
        const re = new RegExp(validationRegEx);
        if (!re.test(value) && value !== '') {
            validation[name]['msg'] = strings.errorInvalid;
            isValid = false;
        }
        validation[name]['valid'] = isValid;
        this.setState({ validation });
    }

    validateRequiredField = (e) => {
        if (e.target.value === '' && e.target.attributes.getNamedItem('required')) {
            const name = e.target.name;
            const validation = { ...this.state.validation };
            validation[name]['msg'] = strings.errorRequired;
            validation[name]['valid'] = false;
            this.setState({ validation });
        }
    }

    getSum = (total, num) => {
        return total + num;
    }

    validateAllRequiredFields = () => {
        const validation = { ...this.state.validation };
        let isReadyToSubmit = { ...this.state.isReadyToSubmit };
        let arrValidation = Object.keys(validation).map((k) => validation[k]);
        let i = arrValidation.map((i) => { 
            return Object.keys(i).map((k) => i[k]);
        })
        .map((i) => { 
            return i.filter((l) => { 
                return typeof(l.valid) !== 'undefined'; 
            }).length; 
        })
        .reduce(this.getSum);
        for (let type in validation) {
            for (let field in validation[type]) {
                if (validation[type][field]['valid']) {
                    i--;
                }
            }
        }
        isReadyToSubmit = (i === 0);
        this.setState({ isReadyToSubmit });
	}
	
    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
	}
	
    render() {
		return (
			<div className="showtix-section container">
				<div className="row">
					<div className="col-12">
						<h1>{strings.title}</h1>
						<p>{strings.content}</p>
					</div>
				</div>

                <form onSubmit={this.sendEmail}>
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <Message
                                message={this.state.message}
                            />
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="username">{strings.username}</label>
                                <div className="showtix-form__input">
                                    <input className="showtix-input"
                                        type="text"
                                        object="user"
                                        id="username"
                                        name="username"
                                        value={this.state.username || ''}
                                        validation="(^(?!\s*$).+)"
                                        onChange={this.handleChange}
                                        onBlur={this.validateRequiredField}
                                        required
                                    />
                                </div>
                                <div className="showtix-note">
                                    <p><Link to="/forgot-username">{strings.forgotUsername}</Link></p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-6">
                            <button
                                type="submit"
                                className="showtix-button showtix-background__primary-1"
                                onClick={this.sendEmail}
                            >
                                <span>{strings.submit}</span>
                            </button>
                        </div>
                    </div>
                </form>    
			</div>
		);
  	}
}

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/components/ForgotPassword/ForgotPassword.js